import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import FilterNav from "src/layouts/ProjectLayout/FilterNav/index";
import FilterProject from "src/components/FilterProject";
import Button from "@mui/material/Button";
import useAuth from "src/hooks/useAuth";

export default function SelectProjectModal({
  title,
  buttonLabel,
  description,
  selectedClientId,
  selectedProjectId,
  onSubmit,
  onClose,
}) {
  const { user } = useAuth();
  const { settings } = user.company;
  const warehouseDropdownEnabled = settings.warehouse_id_dropdown_menu;

  const [clientId, setClientId] = useState(selectedClientId);
  const [projectId, setProjectId] = useState(selectedProjectId);

  const selectProject = ({ clientId, projectId }) => {
    if (projectId) {
      setClientId(clientId);
      setProjectId(projectId);
    } else {
      setClientId(clientId);
    }
  };

  const selectProjectOnly = ({ projectId }) => {
    setProjectId(projectId);
  };

  const selectClient = clientId => {
    setClientId(clientId);
  };

  const handleSubmit = () => {
    onSubmit({
      clientId: warehouseDropdownEnabled ? null : clientId,
      projectId: projectId === "all" ? null : projectId,
    });
  };

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box width={48} />
          <Typography variant="h2" color="textSecondary" component="span">
            {title}
          </Typography>
          <IconButton color="textPrimary" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {description && (
            <Box mb={2}>
              <Typography>{description}</Typography>
            </Box>
          )}
          {warehouseDropdownEnabled ? (
            <FilterProject projectId={projectId} onSelectProject={selectProjectOnly} />
          ) : (
            <Box mr={-2}>
              <FilterNav
                md={12}
                clientId={clientId}
                projectId={projectId}
                onSelectProject={selectProject}
                onSelectClient={selectClient}
                hideActions
              />
            </Box>
          )}
          <Box mt={4} display="flex" justifyContent="flex-end">
            <Button disabled={!projectId} variant="contained" onClick={handleSubmit}>
              {buttonLabel}
            </Button>
          </Box>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
